import React from 'react';
import classNames from  'classnames'

import { Row, Col, Spacer } from '@cleartrip/bento';
import { Table } from 'components/composite';
import { isEmpty } from 'helper/isEmpty';

import { ReactComponent as Chevron } from 'assets/icons/chevron.svg';

function AirlinesUae({ tableHeader, airlinesInfo, caption }) {
	return (
		<>
			<Spacer className='pt-4 pt-0--xs' />
			<Row className='br-4 py-4 mx-0 bg-neutral-0 d-none--xs px-4'>
				{tableHeader.map((item, idx) => (
					<Col key={idx} className='c-neutral-700 fs-3 pl-0' span={item.span}>
						{item.name}
					</Col>
				))}
			</Row>
			<Spacer className='pt-2' />
			{!isEmpty(airlinesInfo) &&
				airlinesInfo.map((item, idx) => (
					<>
						<Table.Row
							key={idx}
							detailsTitle={!isEmpty(item.moreInfo) && item.moreInfo.title}
							detailsList={!isEmpty(item.moreInfo) && item.moreInfo.lists}
							className={classNames('mx-0 py-3 flex-middle px-2--xs px-2', {
								'c-pointer' : !isEmpty(item.moreInfo),
								'c-default' : isEmpty(item.moreInfo)
							})}
						>
							<Col className='c-neutral-700 fs-3 flex flex-between flex-middle pl-2' xs={24} span={4}>
								<div className='flex flex-middle fw-600'>
									<img src={item.airlineLogo} height={28} width={28} alt='logo' />
									<Spacer className='pr-2' />
									{item.name}
								</div>
								{!isEmpty(item.moreInfo)&& (
									<span className='p-relative d-none d-block--xs'>
										<div className='flex'>
											<span className='chevron-text pr-1'>Details</span>
											<Chevron height={16} width={12} className='chevron c-secondary-500 pt-1' />
										</div>
									</span>
								)}
							</Col>

							<Col xs={24} className='flex flex-middle pb-1--xs pt-3--xs c-neutral-400 fs-3 d-none d-block--xs'>
								Baggage limit
							</Col>

							<Col className='c-neutral-700 fs-3 flex flex-middle ' xs={24} span={5}>
								<span className='d-none d-block--xs'>Check-in baggage: {item.checkInBaggage}</span>
								<span className='d-none--xs'>{item.checkInBaggage}</span>
							</Col>
							<Col className='c-neutral-700 fs-3 flex flex-middle pt-1--xs' xs={24} span={6}>
								<span className='d-none d-block--xs'>Cabin baggage: {item.cabbinBaggage}</span>
								<span className='d-none--xs'>{item.cabbinBaggage}</span>
							</Col>
							<Col className=' flex-middle flex c-neutral-700 fs-3 pt-3--xs' xs={24} span={4}>
								<span className='d-none d-block--xs'>Meals in flight: {item.mealsOnFlight}</span>
								<span className='d-none--xs'>{item.mealsOnFlight}</span>
							</Col>
							<Col className=' flex-middle flex c-neutral-700 fs-3 pt-3--xs pb-2--xs' xs={24} span={4}>
								<span className='d-none d-block--xs'>Refund policy: {item.refundPolicy}</span>
								<span className='d-none--xs'>{item.refundPolicy}</span>
							</Col>
							{!isEmpty(item.moreInfo) && (
								<Col span={1} className='d-none--xs flex-middle flex c-neutral-700 fs-3 pr-0'>
									<Chevron height={16} width={12} className='chevron c-secondary-500' />
								</Col>
							)}

							{/* <Col span={1}><Chevro</Col> */}
						</Table.Row>
					</>
				))}
			{caption && <p className='fs-2 c-neutral-400 pt-1'>{caption}</p>}
		</>
	);
}

export default AirlinesUae;
